<template>
    <div v-if="props.items.length > 0" class="shadow-sm py-2 ">
        <div class="text-xl font-semibold">Характеристики</div>
        <ProductCharacteristicTable :characteristic="characteristic"></ProductCharacteristicTable>
        <a v-if="props.items.length > itemMinimizedCount" @click="characteristicShowAll = !characteristicShowAll"
            class="link link-info">
            <template v-if="!characteristicShowAll">
                Показать все
            </template>
            <template v-else>
                Свернуть
            </template></a>
    </div>
</template>
<script lang="ts" setup>
import type { TProductCharacteristic } from '@/types/book_item';
import ProductCharacteristicTable from '@/components/product/ProductCharacteristicTable.vue';
import { computed, ref } from 'vue';

const props = defineProps<{
    items: TProductCharacteristic[]
}>()

const itemMinimizedCount = 4
const characteristicShowAll = ref(false)

const characteristic = computed(() => {
    let list: TProductCharacteristic[] = []
    if (characteristicShowAll.value == false && props.items.length > itemMinimizedCount) {
        for (let i = 0; i < itemMinimizedCount; i++) {
            list.push(props.items[i])
        }
    } else {
        list = props.items
    }

    return list
})

</script>